import React from "react";
import {classNameScrollbar} from "./tools/CommonHtml";
import {useColorModeTheme, UseAsComponent} from "./tools/CommonReact";
import {LazyRoutes, useLevelNavigation} from "./tools/LevelNavigation";
import {usePopPanel} from "./tools/UIPopPanel";
import {useDialogs} from "./tools/UIDialog";
import {appCtx} from "./app/AppContext";
import {CheckAuth} from "./app/Auth";
import {CheckLicense} from "./app/UseLicense";
import {defaultPath, helpActions, menu, routes} from "./routes";
import {SideBar} from "./views/SideBar";
import {NavBar} from "./views/NavBar";


export function Main() {
    useColorModeTheme();
    const {panelCtrl, panelJsx} = usePopPanel();
    Object.assign(appCtx, {tooltip: panelCtrl});

    appCtx.nav = useLevelNavigation(routes, defaultPath);
    if (appCtx.nav.redirected)
        return null;

    return (
        <CheckAuth>
            <CheckLicense>
                <div className="flex">
                    <SideBar {...{menu, helpActions}}/>
                    <div className="grow flex flex-col bg-bg1 h-screen overflow-hidden">
                        <NavBar/>
                        <div className={`p-8 grow h-full relative overflow-auto ${classNameScrollbar} outline-none`}
                             tabIndex={0} ref={el => el && document.activeElement === document.body && el.focus()}>
                            <LazyRoutes {...{routes, defaultPath}}/>
                        </div>
                    </div>
                    <UseAsComponent use={useDialogs} ctrl={appCtx} toJsx={ctrl => ctrl.dialogsJsx}/>
                    {panelJsx}
                </div>
            </CheckLicense>
        </CheckAuth>
    );
}